import {easing} from "popmotion";

const { createBackIn, reversed } = easing;
const lighterBackOut = reversed(createBackIn(1.25));

export const tweenUp = (track, duration = 500, yFrom = 100) => ({
	track,
	duration,
	from: { y: yFrom, opacity: 0 },
	to: { y: 0, opacity: 1 },
	ease: { y: lighterBackOut, opacity: easing.linear }
});

export const tweenLeft = (track, duration = 500, xFrom = 100) => ({
	track,
	duration,
	from: { x: xFrom, opacity: 0 },
	to: { x: 0, opacity: 1 },
	ease: { x: lighterBackOut, opacity: easing.linear }
});

export const setLabels = (items, label) => {
	return items.map((item, i) => label + i);
};
